import { render, staticRenderFns } from "./new_business_property.vue?vue&type=template&id=597089e4&scoped=true&"
import script from "./new_business_property.vue?vue&type=script&lang=js&"
export * from "./new_business_property.vue?vue&type=script&lang=js&"
import style0 from "./new_business_property.vue?vue&type=style&index=0&id=597089e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597089e4",
  null
  
)

export default component.exports